import { useTranslation } from "react-i18next";

type Props = {
  id: number;
  text: string;
  onClick: (id: number) => void;
  isActive?: boolean;
};

export default function FactionOptionModal({ id, text, isActive, onClick }: Props) {
  const { t } = useTranslation("faction");

  return (
    <button
      type="button"
      onClick={() => onClick(id)}
      className="group relative flex justify-between items-center min-h-11 py-3 px-3.5 bg-[#1D1D1D] rounded-xl transition-all duration-200 hover:bg-[#242424]"
    >
      {isActive && (
        <div
          className="absolute top-0 left-0 size-full rounded-xl pointer-events-none"
          style={{
            background:
              "linear-gradient(84deg, rgba(152, 205, 172, 0.00) 73.22%, rgba(152, 205, 172, 0.01) 91.93%, rgba(152, 205, 172, 0.06) 100%)",
          }}
        />
      )}
      <p className="max-w-[14rem] pr-1.5 text-white/60 font-medium text-start transition-all duration-200 group-hover:text-white">
        {text}
      </p>
      {isActive && <p className="text-[#98CDAC] font-bold">{t("faction.current")}</p>}
    </button>
  );
}
